export var LayoutState;

!function(LayoutState) {
    LayoutState.before = "before", LayoutState.layouting = "layouting", LayoutState.reevaluate = "reevaluate", 
    LayoutState.after = "after";
}(LayoutState || (LayoutState = {}));
//# sourceMappingURL=compiler.js.map
